import clsx from "clsx";
import Link from "next/link";
import React from "react";

type Color = "default" | "primary" | "accent";

interface Props {
  label: string;
  className?: string;
  labelClassName?: string;
  labelClassNameContainer?: string;
  color?: Color;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
  href?: string;
  target?: "_blank";
  type?: "button" | "submit";
}

/**
 * カラーをTailwindクラスに変換
 * @param {Color} c
 */
export function colorToClasses(c?: Color) {
  switch (c) {
    case "primary":
      return "text-primary-dark hover:bg-primary-hover";
    case "accent":
      return "text-accent hover:bg-theme-hover";
    case "default":
    default:
      return "text-theme hover:bg-theme-hover";
  }
}

/**
 * 背景色なしテキストボタンです。
 * @param props
 * @returns
 */
const ButtonTextBase: React.FC<Props> = ({
  label,
  className,
  labelClassName = "inline-block",
  labelClassNameContainer,
  onClick,
  disabled,
  href,
  color,
  type = "button",
  ...other
}) => {
  const colorClasses = colorToClasses(color);
  const baseClasses =
    "inline-flex px-2 min-w-[48px] h-11 rounded items-center justify-center font-bold md:transition disabled:pointer-events-none disabled:opacity-30";
  const classNames = [baseClasses, colorClasses, className].join(" ");
  const labelArr: React.ReactElement[] = label.split(" ").map((item, index) => {
    return (
      <span key={index} className={labelClassName}>
        {item}
      </span>
    );
  });

  return (
    <>
      {href ? (
        <Link href={href} className={classNames} {...other}>

          <span className="border-b-[1px] border-[#626262]">{labelArr}</span>

        </Link>
      ) : (
        <button
          className={classNames}
          onClick={onClick}
          disabled={disabled}
          type={type}
          {...other}
        >
          <span
            className={clsx(
              "border-b-[1px] border-[#626262]",
              labelClassNameContainer,
            )}
          >
            {labelArr}
          </span>
        </button>
      )}
    </>
  );
};

export const ButtonText = React.memo(ButtonTextBase);
